/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Geo_Dim_Structured_DataInputs */

const en_directory_detail_signals_geo_dim_structured_data = /** @type {(inputs: Directory_Detail_Signals_Geo_Dim_Structured_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Structured data`)
};

const zh_directory_detail_signals_geo_dim_structured_data = /** @type {(inputs: Directory_Detail_Signals_Geo_Dim_Structured_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结构化数据`)
};

/**
* | output |
* | --- |
* | "Structured data" |
*
* @param {Directory_Detail_Signals_Geo_Dim_Structured_DataInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_geo_dim_structured_data = /** @type {((inputs?: Directory_Detail_Signals_Geo_Dim_Structured_DataInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Geo_Dim_Structured_DataInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_geo_dim_structured_data(inputs)
	return zh_directory_detail_signals_geo_dim_structured_data(inputs)
});
export { directory_detail_signals_geo_dim_structured_data as "directory.detail.signals.geo_dim.structured_data" }